import { Eleve } from 'types/eleves';
import _isEmpty from 'lodash-es/isEmpty';

export function isEleveInDecloisonnement(eleve: Eleve) {
  return !_isEmpty(eleve.decloisonement);
}
